<template>
  <div class="voice-container">
    <div class="head-wrappper">
      <div class="left">
        <img class="avatar" :src="styleData.cover.value" />
      </div>
      <div class="right">
        <div class="name">
          {{ styleData.name.value === "基础时装" ? baseCharacter.name.value : styleData.name.value }}
        </div>
        <div class="txt">{{ currentVoiceDesc }}</div>
        <div class="cv">CV：{{ baseCharacter.cv.value }}</div>
      </div>
    </div>
    <div class="container-box">
      <ElScrollbar style="height: 640px; overflow-y: auto" wrapStyle="overflow-x: hidden;overflow-y: auto">
        <div class="voice-list">
          <!-- 大厅 -->
          <div class="voice-group">
            <div class="group-header" @click="handleExpandGroup('dt')">
              <div class="line"></div>
              <div class="group-name">
                <span class="group-text">大厅</span>
              </div>
              <div class="group-expand">
                <img
                  class="expand-icon"
                  :class="{ expanded: expandGroup.includes('dt') }"
                  src="@/assets/nikke_imgs/expand-icon.png"
                  alt=""
                />
              </div>
            </div>
            <div class="group-list" :style="{ height: !expandGroup.includes('dt') ? 0 : 'auto' }">
              <template v-for="(key, index) in Object.keys(dataSource.dt)">
                <div
                  class="list-item"
                  :key="key"
                  v-if="dataSource.dt[key].source.hasValue && dataSource.dt[key].source.value"
                  @click="handlePlay(`voice_audio_dt_${index}`, `dt.${key}`, $event)"
                >
                  <div class="play-percent" :style="{ width: playPercent + '%' }"></div>
                  <div class="play-icon">
                    <img
                      class="icon"
                      v-if="playKey !== `voice_audio_dt_${index}`"
                      src="@/assets/nikke_imgs/voice-pause-icon.png"
                      alt=""
                    />
                    <img class="icon" v-else src="@/assets/nikke_imgs/voice-play-icon.png" alt="" />
                  </div>
                  <div class="voice-name">
                    {{ dataSource.dt[key].label.value }}
                  </div>
                  <!-- <div class="voice-desc">
                  {{ dataSource.dt[key].desc.value }}
                </div> -->
                  <audio
                    style="display: none;"
                    :id="`voice_audio_dt_${index}`"
                    :src="dataSource.dt[key].source.value"
                    @timeupdate="e => handleAudioTimeUpdate(e, `voice_audio_dt_${index}`)"
                  ></audio>
                </div>
              </template>
            </div>
          </div>
          <!-- 前哨基地 -->
          <div class="voice-group">
            <div class="group-header" @click="handleExpandGroup('qsjd')">
              <div class="line"></div>
              <div class="group-name">
                <span class="group-text">前哨基地</span>
              </div>
              <div class="group-expand">
                <img
                  class="expand-icon"
                  :class="{ expanded: expandGroup.includes('qsjd') }"
                  src="@/assets/nikke_imgs/expand-icon.png"
                  alt=""
                />
              </div>
            </div>
            <div class="group-list" :style="{ height: !expandGroup.includes('qsjd') ? 0 : 'auto' }">
              <template v-for="(key, index) in Object.keys(dataSource.qsjd)">
                <div
                  class="list-item"
                  :key="key"
                  v-if="dataSource.qsjd[key].source.hasValue && dataSource.qsjd[key].source.value"
                  @click="handlePlay(`voice_audio_qsjd_${index}`, `qsjd.${key}`, $event)"
                >
                  <div class="play-percent" :style="{ width: playPercent + '%' }"></div>
                  <div
                    class="play-icon"
                    :data-map-type="dataSource.qsjd[key].source.type"
                    :data-map-key="dataSource.qsjd[key].source.key"
                  >
                    <img
                      class="icon"
                      v-if="playKey !== `voice_audio_qsjd_${index}`"
                      src="@/assets/nikke_imgs/voice-pause-icon.png"
                      alt=""
                    />
                    <img class="icon" v-else src="@/assets/nikke_imgs/voice-play-icon.png" alt="" />
                  </div>
                  <div
                    class="voice-name"
                    :data-map-type="dataSource.qsjd[key].label.type"
                    :data-map-key="dataSource.qsjd[key].label.key"
                  >
                    {{ dataSource.qsjd[key].label.value }}
                  </div>
                  <!-- <div class="voice-desc">
                  {{ dataSource.qsjd[key].desc.value }}
                </div> -->
                  <audio
                    style="display: none;"
                    :id="`voice_audio_qsjd_${index}`"
                    :src="dataSource.qsjd[key].source.value"
                    @timeupdate="e => handleAudioTimeUpdate(e, `voice_audio_qsjd_${index}`)"
                  ></audio>
                </div>
              </template>
            </div>
          </div>
          <!-- 获得与成长 -->
          <div class="voice-group">
            <div class="group-header" @click="handleExpandGroup('hdycz')">
              <div class="line"></div>
              <div class="group-name">
                <span class="group-text">获得与成长</span>
              </div>
              <div class="group-expand">
                <img
                  class="expand-icon"
                  :class="{ expanded: expandGroup.includes('hdycz') }"
                  src="@/assets/nikke_imgs/expand-icon.png"
                  alt=""
                />
              </div>
            </div>
            <div class="group-list" :style="{ height: !expandGroup.includes('hdycz') ? 0 : 'auto' }">
              <template v-for="(key, index) in Object.keys(dataSource.hdycz)">
                <div
                  class="list-item"
                  :key="key"
                  v-if="dataSource.hdycz[key].source.hasValue && dataSource.hdycz[key].source.value"
                  @click="handlePlay(`voice_audio_hdycz_${index}`, `hdycz.${key}`, $event)"
                >
                  <div class="play-percent" :style="{ width: playPercent + '%' }"></div>
                  <div
                    class="play-icon"
                    :data-map-type="dataSource.hdycz[key].source.type"
                    :data-map-key="dataSource.hdycz[key].source.key"
                  >
                    <img
                      class="icon"
                      v-if="playKey !== `voice_audio_hdycz_${index}`"
                      src="@/assets/nikke_imgs/voice-pause-icon.png"
                      alt=""
                    />
                    <img class="icon" v-else src="@/assets/nikke_imgs/voice-play-icon.png" alt="" />
                  </div>
                  <div
                    class="voice-name"
                    :data-map-type="dataSource.hdycz[key].label.type"
                    :data-map-key="dataSource.hdycz[key].label.key"
                  >
                    {{ dataSource.hdycz[key].label.value }}
                  </div>
                  <!-- <div class="voice-desc">
                  {{ dataSource.hdycz[key].desc.value }}
                </div> -->
                  <audio
                    style="display: none;"
                    :id="`voice_audio_hdycz_${index}`"
                    :src="dataSource.hdycz[key].source.value"
                    @timeupdate="e => handleAudioTimeUpdate(e, `voice_audio_hdycz_${index}`)"
                  ></audio>
                </div>
              </template>
            </div>
          </div>
          <!-- 野外 -->
          <div class="voice-group">
            <div class="group-header" @click="handleExpandGroup('yw')">
              <div class="line"></div>
              <div class="group-name">
                <span class="group-text">野外</span>
              </div>
              <div class="group-expand">
                <img
                  class="expand-icon"
                  :class="{ expanded: expandGroup.includes('yw') }"
                  src="@/assets/nikke_imgs/expand-icon.png"
                  alt=""
                />
              </div>
            </div>
            <div class="group-list" :style="{ height: !expandGroup.includes('yw') ? 0 : 'auto' }">
              <template v-for="(key, index) in Object.keys(dataSource.yw)">
                <div
                  class="list-item"
                  :key="key"
                  v-if="dataSource.yw[key].source.hasValue && dataSource.yw[key].source.value"
                  @click="handlePlay(`voice_audio_yw_${index}`, `yw.${key}`, $event)"
                >
                  <div class="play-percent" :style="{ width: playPercent + '%' }"></div>
                  <div
                    class="play-icon"
                    :data-map-type="dataSource.yw[key].source.type"
                    :data-map-key="dataSource.yw[key].source.key"
                  >
                    <img
                      class="icon"
                      v-if="playKey !== `voice_audio_yw_${index}`"
                      src="@/assets/nikke_imgs/voice-pause-icon.png"
                      alt=""
                    />
                    <img class="icon" v-else src="@/assets/nikke_imgs/voice-play-icon.png" alt="" />
                  </div>
                  <div
                    class="voice-name"
                    :data-map-type="dataSource.yw[key].label.type"
                    :data-map-key="dataSource.yw[key].label.key"
                  >
                    {{ dataSource.yw[key].label.value }}
                  </div>
                  <!-- <div class="voice-desc">
                  {{ dataSource.yw[key].desc.value }}
                </div> -->
                  <audio
                    style="display: none;"
                    :id="`voice_audio_yw_${index}`"
                    :src="dataSource.yw[key].source.value"
                    @timeupdate="e => handleAudioTimeUpdate(e, `voice_audio_yw_${index}`)"
                  ></audio>
                </div>
              </template>
            </div>
          </div>
          <!-- 战斗 -->
          <div class="voice-group">
            <div class="group-header" @click="handleExpandGroup('zd')">
              <div class="line"></div>
              <div class="group-name">
                <span class="group-text">战斗</span>
              </div>
              <div class="group-expand">
                <img
                  class="expand-icon"
                  :class="{ expanded: expandGroup.includes('zd') }"
                  src="@/assets/nikke_imgs/expand-icon.png"
                  alt=""
                />
              </div>
            </div>
            <div class="group-list" :style="{ height: !expandGroup.includes('zd') ? 0 : 'auto' }">
              <template v-for="(key, index) in Object.keys(dataSource.zd)">
                <div
                  class="list-item"
                  :key="key"
                  v-if="dataSource.zd[key].source.hasValue && dataSource.zd[key].source.value"
                  @click="handlePlay(`voice_audio_zd_${index}`, `zd.${key}`, $event)"
                >
                  <div class="play-percent" :style="{ width: playPercent + '%' }"></div>
                  <div
                    class="play-icon"
                    :data-map-type="dataSource.zd[key].source.type"
                    :data-map-key="dataSource.zd[key].source.key"
                  >
                    <img
                      class="icon"
                      v-if="playKey !== `voice_audio_zd_${index}`"
                      src="@/assets/nikke_imgs/voice-pause-icon.png"
                      alt=""
                    />
                    <img class="icon" v-else src="@/assets/nikke_imgs/voice-play-icon.png" alt="" />
                  </div>
                  <div
                    class="voice-name"
                    :data-map-type="dataSource.zd[key].label.type"
                    :data-map-key="dataSource.zd[key].label.key"
                  >
                    {{ dataSource.zd[key].label.value }}
                  </div>
                  <!-- <div class="voice-desc">
                  {{ dataSource.zd[key].desc.value }}
                </div> -->
                  <audio
                    style="display: none;"
                    :id="`voice_audio_zd_${index}`"
                    :src="dataSource.zd[key].source.value"
                    @timeupdate="e => handleAudioTimeUpdate(e, `voice_audio_zd_${index}`)"
                  ></audio>
                </div>
              </template>
            </div>
          </div>
        </div>
      </ElScrollbar>
    </div>
  </div>
</template>

<script>
import TextSlider from "@/components/TextSlider";
export default {
  name: "Voice",
  components: { TextSlider },
  props: {
    dataSource: {
      type: Object,
      default: () => {
        return {};
      }
    },
    lhDataSource: {
      type: Object,
      default: () => {
        return {};
      }
    },
    baseCharacter: { type: Object, default: () => ({}) },
    styleData: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      playKey: "",
      playPercent: 0,
      expandGroup: ["dt"],
      sourceKey: "dt.voices1"
    };
  },
  computed: {
    currentVoiceDesc() {
      return this.dataSource[this.sourceKey.split(".")[0]][this.sourceKey.split(".")[1]].desc.value;
    }
  },
  mounted() {},
  methods: {
    handlePlay(key, sourceKey, event) {
      const audio = document.getElementById(key);

      /** @type {HTMLDivElement} */
      let target = event.target;
      target = target.closest("div.list-item");
      /** @type {HTMLDivElement} */
      const percent = target.querySelector("div.play-percent");
      percent.style.transition = `width ${audio.duration}s linear`;
      percent.style.width = "100%";
      setTimeout(() => {
        percent.style.transition = `width 0s`;
        percent.style.width = "0";
      }, audio.duration * 1000 + 1000);

      // 其他的都关闭
      const audios = document.getElementsByTagName("audio");
      for (let i = 0; i < audios.length; i++) {
        audios[i].pause();
        if (target !== audios[i].parentElement) {
          const percent = audios[i].parentElement.querySelector("div.play-percent");
          if (percent) {
            percent.style.removeProperty("transition");
            percent.style.width = "0";
          }
        }
      }
      if (this.playKey == key) {
        this.playKey = "";
        audio.pause();
      } else {
        this.playKey = key;
        audio.play();
      }
      this.sourceKey = sourceKey;
      this.$emit("refresh");
    },
    handleAudioTimeUpdate(e, key) {
      // this.playPercent = (e.target.currentTime / e.target.duration) * 100;
      if (e.target.currentTime >= e.target.duration) {
        setTimeout(() => {
          this.playKey = "";
          e.target.pause();
        }, 1000);
      }
    },
    handleExpandGroup(key) {
      if (this.expandGroup.includes(key)) {
        this.expandGroup = this.expandGroup.filter(item => item !== key);
      } else {
        this.expandGroup.push(key);
      }
    }
  }
};
</script>

<style lang="less" scoped>
.voice-container {
  position: relative;
  z-index: 3;
  flex-grow: 1;
  height: 0;
  display: flex;
  flex-direction: column;
  width: 671px;
  background: url("~@/assets/nikke_imgs/nav-audio-bg.png") center/100% 100% no-repeat rgba(255, 255, 255, 0.09);
}
.head-wrappper {
  display: flex;
  padding: 28px 28px 0;
  align-items: flex-end;
  .left {
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    position: relative;
    width: 74px;
    height: 108px;
    background: url("~@/assets/nikke_imgs/role-base-avatar3.png") top right/cover no-repeat;
    .avatar {
      width: 71px;
      height: 101px;
      object-fit: cover;
      object-position: center;
    }
  }
  .right {
    position: relative;
    width: 536px;
    height: 94px;
    background: url("~@/assets/nikke_imgs/audio-desc-bg.png") center/100% 100% no-repeat;
    padding-left: 40px;
    padding-top: 13px;
    .name {
      position: relative;
      color: #fff;
      font-size: 16px;
      margin-bottom: 7px;
      &::before {
        content: "";
        position: absolute;
        width: 2px;
        height: 100%;
        background-color: #3eaffe;
        top: 0;
        left: -8px;
      }
    }
    .txt {
      color: #ffffff;
      font-size: 14px;
      padding-right: 6px;
    }
    .cv {
      position: absolute;
      top: 13px;
      right: 18px;
      color: #ffffff;
      font-size: 13px;
    }
  }
}
.container-box {
  flex-grow: 1;
  height: 0;
  width: 620px;
  margin: 16px auto;
}
.voice-list {
  overflow-y: auto;
  &::-webkit-scrollbar {
    display: none;
  }
  .voice-group {
    width: 100%;
    margin-top: 26px;
    &:first-child {
      margin-top: 0;
    }
    .group-header {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      height: 32px;
      border-radius: 4px;
      padding: 12px;
      cursor: pointer;
      &::before {
        content: "";
        position: absolute;
        width: 1px;
        height: 90%;
        left: 3px;
        bottom: 0;
        background-image: linear-gradient(to top, rgba(222, 223, 227, 1), rgba(222, 223, 227, 0));
      }
      &::after {
        content: "";
        position: absolute;
        left: 0;
        bottom: 0;
        width: 7px;
        height: 3px;
        background-color: #3eaffe;
      }
      .line {
        position: absolute;
        bottom: 1px;
        left: 0;
        width: 513px;
        height: 1px;
        background-image: linear-gradient(
          90deg,
          rgba(222, 223, 227, 0) 0%,
          rgba(222, 223, 227, 1) 2%,
          rgba(222, 223, 227, 0) 100%
        );
      }
      .group-name {
        display: flex;
        align-items: center;
        .group-text {
          font-size: 15px;
          color: rgba(20, 38, 48, 0.9);
          line-height: 14px;
        }
      }

      .group-expand {
        width: 16px;
        height: 8px;
        .expand-icon {
          width: 100%;
          height: 100%;
          transition: all 0.3s ease;
          &.expanded {
            transform: rotate(180deg);
          }
        }
      }
    }
    .group-list {
      position: relative;
      width: 100%;
      padding: 0 12px;
      height: auto;
      transition: all 1s;
      overflow: hidden;
      &::before {
        content: "";
        position: absolute;
        width: 1px;
        height: 100%;
        min-height: 6px;
        left: 3px;
        top: 0;
        background-image: linear-gradient(
          to bottom,
          rgba(222, 223, 227, 1),
          rgba(222, 223, 227, 1) 60%,
          rgba(222, 223, 227, 0)
        );
      }
      .list-item {
        position: relative;
        z-index: 1;
        display: flex;
        align-items: center;
        width: 100%;
        height: 40px;
        border-radius: 4px;
        box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.3);
        padding: 7px 18px;
        margin: 12px 0;
        cursor: pointer;
        .play-icon {
          position: relative;
          z-index: 1;
          width: 12px;
          height: 14px;
          margin-right: 8px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .play-percent {
          position: absolute;
          left: 0;
          top: 0;
          z-index: 0;
          width: 0;
          height: 100%;
          background: #3eaffe;
        }
        .voice-name {
          position: relative;
          z-index: 1;
          font-weight: 500;
          font-size: 14px;
          color: #45474a;
          line-height: 16px;
        }
        .voice-desc {
          position: relative;
          z-index: 1;
          font-weight: 500;
          font-size: 14px;
          color: #45474a;
          line-height: 16px;
          margin-left: 20px;
        }
      }
    }
  }
}
</style>
